import {tenant} from '../utils/tenantManager'
import { useSelector } from 'react-redux'

const useCurrent = () => {
    const safeParse = (value) => {
        if (!value) return null
        try {
            return JSON.parse(value)
        } catch {
            return null
        }
    }

    const authUser = useSelector(state => state.auth).user
    const storedUser = safeParse(localStorage.getItem('user'))
    const user = authUser || storedUser

    const currentTenantId = tenant()?._id || user?.tenant_id;

    const currentLangList = tenant()?.languages;

    const currentCompanyIdFromState = useSelector(state => state.currentCompany).value
    const currentCompanyId = currentCompanyIdFromState || user?.company_id

    const currentCompany = tenant()?.companies?.filter(company => company._id === currentCompanyId)[0]

    const currentBranchId = useSelector(state => state.currentBranch).value 

    const userId = user?._id 
    const userName = user?.name 


    const currentLangId = useSelector(state => state.lang).value

    const currentSettings = useSelector(state => state.settings);

    return {currentTenantId,currentCompany,currentCompanyId,currentBranchId,user,userId,userName,currentLangList,currentLangId,currentSettings}
}

export default useCurrent
